<template>
    <div class="relative-container">
        <div class="header">
            <div class="title">事件环比</div>
            <CardTabs :data="['日', '周', '月']" 
                :TabsStyle="TabsStyle" 
                @changed="dateChanged"
                :checked="time" >
            </CardTabs>
        </div>
        <div class="content" v-if="status === 'loading'" v-loading="status === 'loading'">
            
        </div>
        <div class="content" v-else-if="status === 'error'">
            error
        </div>
        <div class="content" v-else>
            <div class="bar">
                <BarCharts :barData="barDataWarpper"></BarCharts>
            </div>
            <div class="card">
                <BarCard v-for="(item, index) in cardData" :key="index" :item="item"></BarCard>
            </div>
        </div>
    </div>
</template>

<script>
import CardTabs from './shared/CardTabs';
import BarCharts from './relative/BarCharts';
import BarCard from './relative/BarCard';

const DATE = [['今日', '昨日'], ['本周', '上周'], ['本月', '上月']];
const COLORS = ['#0D94FF', '#E0E5EC']; //蓝 灰

export default {
    props: {
        data: Array,
        time: Number,
        status: String,
    },
    components: {
        CardTabs,
        BarCharts,
        BarCard
    },
    data () {
        return {
            TabsStyle: {
                // width: '121rem'
            },
            checked: 0,
        }
    },
    computed: {
        barX: function() {
            // console.log(this.time,DATE[this.time])
            return DATE[this.time];
        },
        barDataWarpper: function () {
            return this.data.map((item, index) => {
                let data = [item,'-']
                if(index==1){
                    data = ['-',item]
                }
                return {          
                    name: this.barX[index], 
                    type: 'bar',
                    barWidth : 90,
                    data: data,
                    value:item,
                    stack: 'Total',
                    itemStyle: {
                        color: COLORS[index]
                    }
                }
            })
        },
        increaseRate: function () {
            if (!this.data || !this.data[1]) {
                if(this.data[0]==0&&this.data[1]==0){
                    return '--'
                }else if(this.data[1]==0&&this.data[0]!=0){
                    return '100'
                }
            }
            return parseInt((this.data[0] - this.data[1]) * 100 / this.data[1]);
        },
        increase: function () {
            return this.data[0] - this.data[1];
        },
        cardData: function () {
            // return data
            return [
                {
                    name: this.barX[0] + '事件',
                    value: this.data[0],
                    isPercent: false,
                },
                {
                    name: this.barX[1] + '事件',
                    value: this.data[1],
                    isPercent: false,
                },
                {
                    name: '增长率',
                    value: this.increaseRate,
                    isPercent: true,
                },
                {
                    name: '增长值',
                    value: this.increase,
                    isPercent: false,
                }
            ]
        }
    },
    methods: {
        dateChanged: function (index) {
            this.$emit('changed', index);
        }
    }
}
</script>

<style lang="less" scoped>
.relative-container {
    .h(520);
    .w(796);
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 16px 0px rgba(0, 43, 102, 0.04);
    display: flex;
    flex-direction: column;

    .header {
        display: flex;
        justify-content: space-between;
        padding-left: 24rem;
        padding-right: 24rem;
        height: 64rem;
        line-height: 64rem;

        .title {
            font-size: 18rem;
            font-weight: bold;
            color: #333333;
        }
    }

    .content {
        // background: chartreuse;
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;

        .bar {
            // background: chocolate;
            width: 70%;
            height: 100%;
        }

        .card {
            flex: 1;
            align-self: center;
            // background: chartreuse;
            .h(332);
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            padding-right: 24rem;
        }
    }
}
</style>